export const types = <const>{
	mutations: {
		PRACOVNIK_SELECT_MAPPER: 'PRACOVNIK_SELECT_MAPPER',
	},
};
